import axios  from "../../services/axios";
import { constants } from '../../constants';



export const fetchWholesaleInventoryDetails = async () => {
  try {
    const response = await axios.get(`/wholesale/view-inventories`);
        return response.data;
    
   
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      'Failed to fetch wholesale inventory details. Please try again later.';
    throw new Error(message);
  }
};

export const createWholesaleInventory = async (formData) => {
  try {
    const payload = new FormData();
    if (formData.file) {
      payload.append('file', formData.file);
    }

    const response = await axios.post('/wholesale/upload-inventory', payload);
    return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      'Failed to import wholesale inventory. Please try again.';
    throw new Error(message);
  }
};


;

export const downloadWholesaleInventory = async () => {
  try {
    const response = await axios.get(`/wholesale/download-inventory`,
      {
        responseType: 'blob'
      }
    );
    return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      'Failed to fetch wholesale inventory details. Please try again later.';
    throw new Error(message);
  }
};